var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._t("title",function(){return [_vm._v(_vm._s(this.$t('title.course')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }